export function activeConversation(infos, boll) {
  return {
    type: '@ACTIVE_CONVERSATION',
    infos,
    boll
  };
}

export function handleInfosUser(infos) {
  return {
    type: '@HANDLE_INFOS_USER',
    infos
  };
}

export function addMessage(
  messages,
  id,
  sender,
  isSocketUpdate,
  mensagemId,
  isGroupMessage = false
) {
  return {
    type: '@ADD_MESSAGE',
    messages,
    id,
    sender,
    isSocketUpdate,
    mensagemId,
    isGroupMessage
  };
}

export function orderChat(from) {
  return {
    type: '@ORDER_CHAT',
    from
  };
}

export function getListuser(list) {
  return {
    type: '@GET_LIST_USER_CHAT_INTERNAL',
    list
  };
}

export function removeChat(data) {
  return {
    type: '@REMOVE_CHAT_SPECIFIC',
    data
  };
}

export function watchNewMessages(data) {
  return {
    type: '@WATCH_NEW_MESSAGE',
    newMessages: data
  };
}

export function updateMessageStatus(conversationId, messageId, status, sender) {
  return {
    type: '@UPDATE_MESSAGE_STATUS',
    conversationId,
    messageId,
    newStatus: status,
    sender
  };
}

export function updateMessageGroupStatus(
  groupId,
  messageId,
  statusByUser,
  globalStatus,
  sender
) {
  return {
    type: '@UPDATE_MESSAGE_GROUP_STATUS',
    groupId,
    messageId,
    statusByUser: statusByUser,
    globalStatus: globalStatus,
    sender
  };
}

export const SET_GROUP_ADMINS = 'internalChat/SET_GROUP_ADMINS';
export function setGroupAdmins(groupId, adms) {
  return {
    type: SET_GROUP_ADMINS,
    payload: { groupId, adms }
  };
}
